import React, { SyntheticEvent, useState } from "react";
import {
  Avatar,
  Box,
  ClickAwayListener,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Snackbar,
  Stack,
  Typography,
} from "@mui/material";
import ShareLink from "../sharelink/sharelink";
import { InfoOutlined as InfoOutlinedIcon } from "@mui/icons-material";
import PujaEndTimer from "../Timer/PujaEndTimer";
import { ErrorOutline as ErrorOutlineIcon } from "@mui/icons-material";
import templeIcon from "../../assets/temple-icon.png";
import locationIcon from "../../assets/loc-icon.png";
import pricetagIcon from "../../assets/price-tag.png";
import couponIcon from "../../assets/coupon.png";
import { orderType } from "../../utils/Constants";
import { LOCALIZATION } from "../../utils/localization";
import { t } from "i18next";
import "./ServiceInfo.scss";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import BoldText from "../boldText/BoldText";
import ShowMoreShowLess from "../ShowMoreShowLess/ShowMoreShowLess";
import { truncateToTwoDecimals } from "../../utils/HelperFunctions";

function ServiceInfo(props: any) {
  const {
    pujaName,
    templeName,
    templeAddress,
    finalPujaPriceText,
    bookedCount,
    bookedText,
    itemOrderType,
    urlToShare,
    pujaEndTime,
    tithiName,
    chadhavaDescription,
    couponCodeText,
    chadhaveTithiName,
    chadhavaTitle,
    offerActualPrice,
    currencySymbols,
    overSeasRate,
    isOverseas
  } = props;

  const [isPopUpOpen, setIsPopUpOpen] = useState(false);
  const [open, setOpen] = useState<boolean>(false);

  const handlePriceInfoOpen = () => setIsPopUpOpen(true);
  const handlePriceInfoClose = () => setIsPopUpOpen(false);

  const handleClick = () => {
    setOpen(true);
    navigator.clipboard.writeText(couponCodeText);
  };

  const handleClose = (event: SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  return (
    <>
      <Box className="pujaDescription">
        <Box className="pujaNameInfo">
          <Typography>
            {itemOrderType === orderType.chadhava ? chadhavaTitle : pujaName}
          </Typography>
        </Box>
        <Box className="nameLocPrice">
          <List>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              className="twoItem"
            >
              <ListItem>
                <ListItemAvatar sx={{ minWidth: "35px" }}>
                  <Avatar alt="Temple Icon" className="squreShape temple">
                    <img src={templeIcon} alt="temp icon"></img>
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={
                    itemOrderType === orderType.puja ||
                    itemOrderType === orderType.chadhava
                      ? `${templeName}, ${templeAddress}`
                      : templeName
                  }
                />
              </ListItem>

              <Box className="shareIcon">
                <ShareLink urlToShare={urlToShare} type={itemOrderType}></ShareLink>
              </Box>
            </Stack>

            {itemOrderType === orderType.prasad &&
              templeAddress?.trim().length > 0 && (
                <ListItem>
                  <ListItemAvatar sx={{ minWidth: "35px" }}>
                    <Avatar alt="Location Icon" className="squreShape location">
                      <img src={locationIcon} alt="Location Icon"></img>
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary={`${templeAddress}`} />
                </ListItem>
              )}

            {tithiName?.trim().length > 0 && (
              <ListItem>
                <ListItemAvatar sx={{ minWidth: "35px" }}>
                  <Avatar alt="Tithi Icon" className="squreShape tithi">
                    <CalendarMonthIcon sx={{ color: "#d56939" }} />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={<BoldText text={tithiName} />}
                  primaryTypographyProps={{ fontWeight: 500 }}
                />
              </ListItem>
            )}

            {itemOrderType === orderType.puja && (
              <ListItem>
                <ListItemAvatar sx={{ minWidth: "35px" }}>
                  <Avatar alt="Pricetag Icon" className="squreShape pricetag">
                    <img src={pricetagIcon} alt="Price tag Icon"></img>
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  className="pujaPriceInfo"
                  sx={{ flex: "0 0 auto" }}
                  primary={finalPujaPriceText}
                />
                {offerActualPrice > 0 && (
                  <Typography
                    component="span"
                    className="previousPrice"
                    sx={{
                      textDecoration: "line-through",
                      marginLeft: "8px",
                      color: "#838383",
                      fontSize: "14px",
                      position: "relative",
                      top: "2px",
                    }}
                  >
                    {currencySymbols ?? "₹"}{" "}
                    {(isOverseas
                      ? truncateToTwoDecimals(
                          offerActualPrice * (overSeasRate ?? 1)
                        )
                      : offerActualPrice
                    )?.toLocaleString("en-IN")}
                  </Typography>
                )}

                {/* Info Button & PopUp Here */}
                <Box className="infoContainer">
                  <ClickAwayListener onClickAway={handlePriceInfoClose}>
                    <Box>
                      <InfoOutlinedIcon
                        className="infoIcon"
                        onClick={handlePriceInfoOpen}
                        onMouseEnter={handlePriceInfoOpen}
                      />
                      {isPopUpOpen && (
                        <Box
                          className="popupBox"
                          onMouseLeave={handlePriceInfoClose}
                        >
                          <Typography className="messageTitle">
                            {t(LOCALIZATION.Price)}
                          </Typography>
                          <Typography className="messageText">
                            {t(
                              LOCALIZATION.The_price_does_not_include_Prasad_delivery
                            )}
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  </ClickAwayListener>
                </Box>
              </ListItem>
            )}
            <ListItem>
              {couponCodeText && (
                <>
                  <ListItemAvatar sx={{ minWidth: 35 }}>
                    <Avatar alt="Pricetag Icon" className="squreShape pricetag">
                      <img src={couponIcon} alt="Coupon tag Icon" />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    sx={{ flex: "0 0 auto", cursor: "pointer" }}
                    onClick={handleClick}
                  >
                    <Typography className="couponDiscountCode">
                      Coupon: {couponCodeText}
                    </Typography>
                  </ListItemText>
                </>
              )}
            </ListItem>

            {itemOrderType === orderType.chadhava && (
              <ListItem>
                <ListItemAvatar sx={{ minWidth: "35px" }}>
                  <Avatar alt="Tithi Icon" className="squreShape tithi">
                    <CalendarMonthIcon sx={{ color: "#d56939" }} />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <BoldText
                      text={chadhaveTithiName?.trim() || "Chadhava Offering"}
                    />
                  }
                  primaryTypographyProps={{ fontWeight: 500 }}
                />
              </ListItem>
            )}

            {itemOrderType === orderType.puja && (
              <ListItem>
                <Box className="pujaCloseTimer">
                  <PujaEndTimer endDate={pujaEndTime} />
                </Box>
              </ListItem>
            )}
            <ListItem>
              <Box className="devoteeInfomation">
                <Typography className="countText">
                  <span>{bookedCount}+</span> {bookedText}
                </Typography>
              </Box>
            </ListItem>

            {itemOrderType === orderType.chadhava && chadhavaDescription && (
              <ListItem>
                <Box className="bottomDescription">
                  <Typography className="description">
                    <ShowMoreShowLess 
                    text={chadhavaDescription} 
                    mode="line"
                    lines={2}
                    // limit={300} 
                    />
                  </Typography>
                </Box>
              </ListItem>
            )}

            <ListItem>
              <Typography className="disclaimerText">
                <ErrorOutlineIcon />
                {t(LOCALIZATION.Prices_may_vary_depending_on_your_Country)}
              </Typography>
            </ListItem>
          </List>
        </Box>
        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={handleClose}
          message="Coupon code copied "
        />
      </Box>
    </>
  );
}

export default ServiceInfo;
